import React from "react";

function Loading() {
  return <div className="App"></div>;
}

export default Loading;
